export function makeSharedLink(route,token){
  return "链接: " + route + "  提取码: " + token
}